import { render } from "./TdmInfoView.vue?vue&type=template&id=078cf60f&scoped=true&ts=true"
import script from "./TdmInfoView.vue?vue&type=script&lang=ts"
export * from "./TdmInfoView.vue?vue&type=script&lang=ts"

import "./TdmInfoView.vue?vue&type=style&index=0&id=078cf60f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078cf60f"]])

export default __exports__